import {
  Component,
  HostBinding,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { toBoolean } from '../util';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'tag-select',
  template: `
    <ng-content></ng-content>
    <a *ngIf="expandable" class="trigger" (click)="trigger()">
    {{expand ? 'æ¶èµ·' : 'å±å¼'}}
    <i class="anticon anticon-{{expand ? 'up' : 'down'}} ml-sm"></i></a>`,
  // tslint:disable-next-line:use-host-property-decorator
  host: { '[class.ad-tag-select]': 'true' },
  preserveWhitespaces: false,
})
export class TagSelectComponent {
  /** æ¯å¦å¯ç¨ `å±å¼ä¸æ¶è¿` */
  @HostBinding('class.has-expand')
  @Input()
  get expandable() {
    return this._expandable;
  }
  set expandable(value: any) {
    this._expandable = toBoolean(value);
  }
  private _expandable = true;

  @HostBinding('class.expanded') expand = false;

  @Output() change: EventEmitter<boolean> = new EventEmitter<boolean>();

  trigger() {
    this.expand = !this.expand;
    this.change.emit(this.expand);
  }
}
